import { motion } from "motion/react"

const CLIENT_NAMES = ["Total", "Kenjosset", "TTT", "Go", "Terapolis", "TTR"]

interface ClientsProps {
  section_title: string
  section_title_highlight: string
}

export default function Clients({ section_title, section_title_highlight }: ClientsProps) {
  return (
    <section id="clients" className="py-24 bg-[#0a0a0f] scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            {section_title}{" "}
            <span className="bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
              {section_title_highlight}
            </span>
          </h2>
          <div className="w-20 h-px bg-gradient-to-r from-violet-500 to-cyan-500 mx-auto" />
        </motion.div>

        <div className="flex flex-wrap justify-center gap-6 sm:gap-10">
          {CLIENT_NAMES.map((name, index) => (
            <motion.div
              key={name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="group flex items-center justify-center px-8 py-4 bg-white/5 border border-white/10 rounded-xl hover:border-white/20 hover:bg-white/[0.08] transition-all duration-300"
            >
              <span className="text-lg font-semibold text-slate-500 group-hover:text-white transition-colors duration-300">
                {name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
